<template>
  <background-check-overview
    :badges="badges"
    :idv="idv"
    :showManagedCopy="editModeActive"
    :viewerAccountData="viewerAccountData"
    :isProfileOwner="isProfileOwner"
    :sitterId="sitterId"
    :accountTypeInfo="accountTypeInfo"
    :editModeActive="editModeActive"
    @login-clicked="trackTrustAndSafetyLogin"
    @run-check-clicked="trackParentRunCheckClick"
  />
</template>

<script lang="ts">
import BackgroundCheckOverview from '@/components/background_check_overview/BackgroundCheckOverview.vue';
import { sendSegmentEvent } from '@/lib/segment';

interface Badge {
  completedAt: Date;
  expiresAt: Date;
  name: string;
  status: string;
}

interface IDV {
  latestUpdate: Date;
  provider: string;
  status: string;
  verdict: string;
}

export default {
  name: 'ProfileTrustAndSafety',
  components: {
    BackgroundCheckOverview,
  },
  props: {
    badges: {
      type: Array as () => Badge[],
      default: () => [],
    },
    idv: {
      type: Object as () => IDV,
      default: () => ({}),
    },
    viewerAccountData: {
      type: Object,
      default: () => ({}),
    },
    isProfileOwner: {
      type: Boolean,
      default: false,
    },
    sitterId: {
      type: String,
      default: '',
    },
    careType: {
      type: String,
      default: '',
    },
    accountTypeInfo: {
      default: () => ({}),
      type: Object,
    },
    editModeActive: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    trackTrustAndSafetyLogin(): void {
      sendSegmentEvent('Trust and Safety Login Clicked', {
        sitter_uuid: this.$route.params.sitter_uuid,
        care_type: this.$route.params.care_type,
      });
    },
    trackParentRunCheckClick(): void {
      sendSegmentEvent('Run Check Clicked', {
        sitter_uuid: this.$route.params.sitter_uuid,
        care_type: this.$route.params.care_type,
      });
    },
  },
};
</script>
